var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3rem",
    height: "3rem",
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 30.5,
    cy: 30.7207,
    r: 30,
    fill: "#D7EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3562 38.7207V36.0616L30.5692 30.3088C31.0977 29.7974 31.5408 29.3372 31.8988 28.9281C32.2624 28.519 32.538 28.1184 32.7255 27.7264C32.913 27.3287 33.0067 26.8997 33.0067 26.4395C33.0067 25.9281 32.8903 25.4877 32.6573 25.1184C32.4244 24.7434 32.1062 24.4565 31.7028 24.2576C31.2994 24.0531 30.842 23.9508 30.3306 23.9508C29.7965 23.9508 29.3306 24.0588 28.9329 24.2747C28.5352 24.4906 28.2283 24.8002 28.0124 25.2037C27.7965 25.6071 27.6886 26.0872 27.6886 26.644H24.1857C24.1857 25.502 24.4442 24.5105 24.9613 23.6696C25.4783 22.8287 26.2028 22.1781 27.1346 21.7179C28.0664 21.2576 29.1403 21.0275 30.3562 21.0275C31.6062 21.0275 32.6942 21.2491 33.6204 21.6923C34.5522 22.1298 35.2766 22.7377 35.7937 23.5162C36.3107 24.2946 36.5692 25.1866 36.5692 26.1923C36.5692 26.8514 36.4386 27.502 36.1772 28.144C35.9215 28.786 35.4641 29.4991 34.805 30.2832C34.146 31.0616 33.217 31.9963 32.0181 33.0872L29.4698 35.5843V35.7037H36.7994V38.7207H24.3562Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive2);
export default __webpack_public_path__ + "static/media/active2.779143a77d1ff82e26c3cabc99f42f8c.svg";
export { ForwardRef as ReactComponent };